var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_gray",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11231",
    "data-name": "Rectangle 11231",
    width: 18,
    height: 18,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46304",
    "data-name": "Path 46304",
    d: "M16.59,9H15V4a1,1,0,0,0-1-1H10A1,1,0,0,0,9,4V9H7.41a1,1,0,0,0-.71,1.71l4.59,4.59a1,1,0,0,0,1.41,0l4.59-4.59A1,1,0,0,0,16.59,9ZM5,19a1,1,0,0,0,1,1H18a1,1,0,0,0,0-2H6A1,1,0,0,0,5,19Z",
    transform: "translate(-5 -3)",
    fill: "#92a1b6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGray);
export default __webpack_public_path__ + "static/media/download_gray.dcf9b9d2f7ef510f39d77e5436f784f6.svg";
export { ForwardRef as ReactComponent };